import { IHttpAdapter } from '../../core/entities/iHttpAdapter';
import { API_IDS } from '@intigral/constant';
import { IUserCdnRepository } from '../../core/repositories/interfaces/iUserCdnRepository';

import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IApiPathManager } from '../config/ApiPathManager';

export class UserCdnRepository implements IUserCdnRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getUserRevision(bucketId: number): Promise<any> {
        const response = await this.http?.get(this.apiPathManager.getPath(API_IDS.USER_CDN_API_USER_REVISION), {
            params: {
                bucketId,
            },
        });
        return response?.data;
    }
}

export default UserCdnRepository;
